// Formulario de datos de facturación, común a /registro/datos y a «Mi cuenta».
// Campos en templates/includes/datos_fiscales.html. Uso: const f = tereket.datosFiscales(form, { alCambiarTipo }).
// Devuelve { valores(), validar(), fijar(valores), tipo() }.
window.tereket.datosFiscales = function (form, opciones) {
	opciones = opciones || {};
	// Búsqueda dentro del formulario: en «Mi cuenta» hay otros formularios en la misma página.
	const $ = (id) => form.querySelector("#" + id);
	let tipo = form.dataset.tipo || "Autónomo";
	let temporizador;

	const campos = ["nombre", "apellidos", "razon_social", "nif", "telefono", "direccion_linea_1",
		"codigo_postal", "ciudad", "provincia"];
	// Los campos de texto que se envían tal cual al servidor.
	const textos = ["nombre", "apellidos", "razon_social", "nif", "telefono", "direccion_linea_1",
		"direccion_linea_2", "codigo_postal", "ciudad"];

	const esEspana = () => $("pais").value === "Spain";

	function pintarTipo() {
		form.querySelectorAll("button[data-tipo]").forEach((b) => b.classList.toggle("active", b.dataset.tipo === tipo));
		$("bloque-autonomo").hidden = tipo !== "Autónomo";
		$("bloque-empresa").hidden = tipo !== "Empresa";
		if ($("etiqueta-telefono")) $("etiqueta-telefono").textContent = tipo === "Empresa" ? "Teléfono de la empresa" : "Teléfono";
		pintarEtiquetaNif();
		comprobarNif();
		if (opciones.alCambiarTipo) opciones.alCambiarTipo(tipo);
	}

	function pintarEtiquetaNif() {
		$("etiqueta-nif").textContent = !esEspana() ? "Identificador fiscal" : (tipo === "Empresa" ? "CIF" : "NIF / NIE");
	}

	function pintarPais() {
		const es = esEspana();
		$("provincia").hidden = !es;
		$("provincia_texto").hidden = es;
		pintarEtiquetaNif();
		comprobarNif();
	}

	// Rellena la provincia con los 2 primeros dígitos del CP.
	function provinciaDesdeCp() {
		if (!esEspana()) return;
		const cp = $("codigo_postal").value.trim();
		const opcion = /^\d{5}$/.test(cp) && $("provincia").querySelector(`option[data-cp="${cp.slice(0, 2)}"]`);
		if (opcion) $("provincia").value = opcion.value;
	}

	// Validación del NIF/CIF en directo; la lógica vive solo en Python.
	function comprobarNif() {
		clearTimeout(temporizador);
		const nif = $("nif").value.trim();
		$("ok-nif").hidden = true;
		tereket.errorCampo("nif", "");
		if (!nif || !esEspana()) return;
		temporizador = setTimeout(async () => {
			try {
				const r = await tereket.llamar("tereket_portal.api.registro.validar_nif", { nif, tipo, pais: $("pais").value });
				if ($("nif").value.trim() !== nif) return; // respuesta obsoleta
				$("ok-nif").hidden = !r.valido;
				tereket.errorCampo("nif", r.valido ? "" : (tipo === "Empresa" ? "El CIF no es válido." : "El NIF/NIE no es válido."));
			} catch (e) { /* la validación definitiva la hace el servidor */ }
		}, 300);
	}

	function valorProvincia() {
		return esEspana() ? $("provincia").value : $("provincia_texto").value.trim();
	}

	function validar() {
		const obligatorios = {
			nif: "El NIF/CIF es obligatorio.",
			direccion_linea_1: "La dirección es obligatoria.", codigo_postal: "El código postal es obligatorio.",
			ciudad: "La ciudad es obligatoria.",
		};
		if ($("telefono")) obligatorios.telefono = "El teléfono es obligatorio.";
		if (tipo === "Autónomo") { obligatorios.nombre = "El nombre es obligatorio."; obligatorios.apellidos = "Los apellidos son obligatorios."; }
		else obligatorios.razon_social = "La razón social es obligatoria.";
		let ok = true;
		campos.forEach((c) => $(c) && tereket.errorCampo(c, ""));
		for (const [c, msg] of Object.entries(obligatorios)) {
			if (!$(c).value.trim()) { tereket.errorCampo(c, msg); ok = false; }
		}
		if (!valorProvincia()) { tereket.errorCampo("provincia", "La provincia es obligatoria."); ok = false; }
		if (esEspana() && $("codigo_postal").value.trim() && !/^\d{5}$/.test($("codigo_postal").value.trim())) {
			tereket.errorCampo("codigo_postal", "El código postal debe tener 5 dígitos."); ok = false;
		}
		return ok;
	}

	function valores() {
		const v = { tipo, provincia: valorProvincia(), pais: $("pais").value };
		textos.forEach((c) => { if ($(c)) v[c] = $(c).value; });
		return v;
	}

	// Restaura el formulario (p. ej. al cancelar la edición).
	function fijar(v) {
		textos.forEach((c) => { if ($(c) && v[c] !== undefined) $(c).value = v[c]; });
		if (v.pais !== undefined) $("pais").value = v.pais;
		if (v.provincia !== undefined) {
			$("provincia").value = v.provincia;
			$("provincia_texto").value = v.provincia;
		}
		tipo = v.tipo || tipo;
		[...form.querySelectorAll(".tk-error")].forEach((e) => { e.textContent = ""; });
		form.querySelectorAll(".is-invalid").forEach((e) => e.classList.remove("is-invalid"));
		pintarTipo();
		pintarPais();
	}

	form.querySelectorAll("button[data-tipo]").forEach((b) => b.addEventListener("click", () => { tipo = b.dataset.tipo; pintarTipo(); }));
	$("nif").addEventListener("input", comprobarNif);
	$("codigo_postal").addEventListener("input", provinciaDesdeCp);
	$("pais").addEventListener("change", pintarPais);

	pintarTipo();
	pintarPais();
	return { valores, validar, fijar, tipo: () => tipo };
};
